import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as Keycloak_ from 'keycloak-js';
import { JwtHelperService } from "@auth0/angular-jwt";
import { AuthToken, Comparator, IDTokenDecoded, Resources } from '../models/Resources';
import { AccesTokenService } from './AccesTokenService';
import { Router } from '@angular/router';
declare const require: any;

const qs = require("qs");
const Keycloak = Keycloak_;
const jwtHelperService: JwtHelperService = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class LoginService {
refreshTokenFirstTime:boolean=false;
  constructor(
    private httpClient: HttpClient,
    private router: Router
  ) { }

  public login(user: any): Promise<{}> {
    return new Promise((resolve, reject) => {
        const headers: HttpHeaders = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Accept: "application/json"
        });
        let params = {
            grant_type: "password",
            username: user.login,
            password: user.motDePasse,
            client_id: environment.keycloakConfig.clientId,
            scope: 'openid',
            client_secret: environment.keycloakConfig.client_secret
        };

        const body = qs.stringify(params);
        let url = Resources.Constant.API.LOGIN;
        this.httpClient
            .post(url, body, { headers: headers })
            .pipe(timeout(Resources.Constant.TIME_OUT.LOGIN))
            .subscribe(
                (token: AuthToken) => {
                    if (Comparator.isEmpty(token)) {
                        reject(new Error("User token is null"));
                    } else {
                        this.handleNewToken(token);
                        resolve(true);
                    }
                },
                error => {
                    reject(error.error_description);
                }
            );
    });
}

private async handleNewToken(authToken: AuthToken) {
  if (authToken) {
      const user: IDTokenDecoded = jwtHelperService.decodeToken(authToken.id_token);
      await AccesTokenService.setAccessToken(authToken);
  } else {
      await AccesTokenService.setAccessToken(null);
  }
}

public async getToken(refresh = false) {
    let authToken = AccesTokenService.getAccessToken();
    if (authToken && authToken != undefined) {
        let expiredDtateAccssToken = jwtHelperService.getTokenExpirationDate(authToken.access_token) 
        let expiredDtaterefresh = jwtHelperService.getTokenExpirationDate(authToken.refresh_token)
        if (expiredDtaterefresh.getTime()> new Date().getTime()&& new Date().getTime()>=expiredDtateAccssToken.getTime()) {
            authToken = await this.refresh();
        }else if(expiredDtaterefresh.getTime()< new Date().getTime()){
            localStorage.removeItem('userinfo'); 
            localStorage.removeItem('ring_token'); 
            localStorage.removeItem('RingsForWomen'); 
            localStorage.removeItem('RingsForMen'); 
            localStorage.removeItem('verify_code');
            localStorage.removeItem('firebase:host:ring-a981b.firebaseio.com'); 
            this.router.navigate(['/auth/register']);
            window.location.reload()
        }
    } else {
        return null;
    }
    //this.logsService.trace('AuthService.getToken - end', TRACE_LEVEL.DEBUG, "token : " + JSON.stringify(authToken));
    return authToken.access_token;

}

async refresh(): Promise<AuthToken> {
    try {
        let token: AuthToken = AccesTokenService.getAccessToken();
        if (token && this.refreshTokenFirstTime==false) {
            this.refreshTokenFirstTime=true;
            setTimeout(() => {
                this.refreshTokenFirstTime=false;
            }, 10000);
                const headers: HttpHeaders = new HttpHeaders({
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Accept": "application/json"
                });
                let params = {
                    grant_type: "refresh_token",
                    client_id: environment.keycloakConfig.clientId,
                    refresh_token: token.refresh_token,
                    client_secret: environment.keycloakConfig.client_secret
                };

                const body = qs.stringify(params);
                let url = Resources.Constant.API.LOGIN;
                this.httpClient
                    .post(url, body, { headers: headers })
                    .pipe(timeout(3000))
                    .subscribe(async (token: AuthToken) => {
                        if (Comparator.isEmpty(token)) {
                            return new Error("User token is null");
                        } else {
                            await this.handleNewToken(token);
                            return token;
                        }
                    },
                        error => {
                            if (error.status == 400 || error.status == 401) {
                                // localStorage.clear();
                                localStorage.removeItem('userinfo'); 
                                localStorage.removeItem('ring_token'); 
                                localStorage.removeItem('RingsForWomen'); 
                                localStorage.removeItem('RingsForMen'); 
                                localStorage.removeItem('verify_code');
                                localStorage.removeItem('firebase:host:ring-a981b.firebaseio.com'); 
                                this.router.navigate(['/auth/register']);
                                window.location.reload()
                            }
                        }
                    );

            

        }
        await this.handleNewToken(token);
        return token;

    } catch (error) {
        return null;
    }
}
}
